import { Model } from "@vuex-orm/core";

export default class Settings extends Model {
  static entity = "settings";

  static fields() {
    return {
      id: this.attr(),
      isDirty: this.boolean(false),
      // accountId: this.number(0),
      userId: this.number(0),
      showCustomerDetail: this.boolean(true),
      lastUpdateFromServer: this.number(0),

      balance: this.number(0),

      callIsUnreadCount: this.number(0),
      callIsArchivedCount: this.number(0),

      chatIsNotEndedCount: this.number(0),
      chatIsUnreadCount: this.number(0),
      chatHaveNotRespondedCount: this.number(0),

      messageIsUnreadCount: this.number(0),
      messageIsSnoozedCount: this.number(0),
      messageIsArchivedCount: this.number(0),
      messageHaveNotRespondedCount: this.number(0),

      customerSettings: this.attr().nullable(),
      calendarSettings: this.attr().nullable(),
      telecomSettings: this.attr().nullable(),

      isOffline: this.boolean(false),
      serverErrorMessage: this.attr().nullable()
    };
  }
}
